import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';
import { getCountryCallingCode, type CountryCode } from 'libphonenumber-js';

countries.registerLocale(enLocale);

const unsupportedCountries = ['AQ', 'BV', 'TF', 'HM', 'PN', 'GS', 'UM'];

const supportedCountries = Object.entries(countries.getNames('en')).reduce<
  ReturnType<typeof countries.getNames>
>((result, [code, name]) => {
  if (unsupportedCountries.includes(code)) {
    return result;
  }

  return {
    ...result,
    [code]: name,
  };
}, {});

export function getCountries(): ReturnType<typeof countries.getNames> {
  return supportedCountries;
}

export function getCountryCode(country: string): string | undefined {
  return countries.getAlpha2Code(country, 'en');
}

export function getCountryName(countryCode: string): string | undefined {
  return countries.getName(countryCode, 'en');
}

export type TCode = `+${string}`;

export interface ICountryProps {
  name: string;
  code: string;
  phoneCode: TCode;
}

export function getFullCountries(): ICountryProps[] {
  return Object.entries(supportedCountries).reduce<ICountryProps[]>(
    (result, [code, name]) => {
      result.push({
        code,
        name,
        phoneCode: `+${getCountryCallingCode(code as CountryCode)}`,
      });

      return result;
    },
    [],
  );
}
